import React from 'react';
import { useSymbolPrices } from '../../../context/WebSocketContext';

export default function DailyChange({ symbolId, digits }) {
    const { [symbolId]: symbol } = useSymbolPrices();

    if (!symbol || !symbol.open) return <span>--</span>;

    const absoluteChange = (symbol.bid - symbol.open).toFixed(digits);
    const color = absoluteChange < 0 ? "#da5244" : "#3687ed";

    return <span className={`${absoluteChange < 0 ? "red" : "green"}`}>{absoluteChange}</span>;
}
